import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  ownerType: null,
  ownerId: null,
  ownerName: null,
  analysis: null,
  analysisFailed: false,
  analysisFailedErrorCode: null,
  analysisFailedMessage: null,
  categories: null,
  terms: [],
  operationId: null,
  overview: null,
  isLoading: false,
  isLoadingTerms: false,
  isSubmitting: false,
  progressHistory: [],
  sseError: false,
  connectionAttempts: 0,
  connectionError: null,
};

const technicalAlignmentSlice = createSlice({
  name: "technicalAlignment",
  initialState: INITIAL_STATE,
  reducers: {
    setOwner(state, { payload }) {
      const { ownerType = null, ownerId = null, ownerName = null } =
        payload || {};
      state.ownerType = ownerType;
      state.ownerId = ownerId;
      state.ownerName = ownerName;
    },
    clearOwner(state) {
      const { overview } = state;
      return { ...INITIAL_STATE, overview };
    },
    addProgressHistory(state, { payload }) {
      state.progressHistory = state.progressHistory.concat(payload);
    },
    clearAll(state) {
      state.analysis = null;
      state.analysisFailed = false;
      state.analysisFailedErrorCode = null;
      state.analysisFailedMessage = null;
      state.overview = null;
      state.progressHistory = [];
    },
    clearAnalysisFailed(state) {
      state.analysisFailed = false;
      state.analysisFailedErrorCode = null;
      state.analysisFailedMessage = null;
    },
    clearAnalysisProgress(state) {
      state.analysis = null;
      state.analysisFailed = false;
      state.analysisFailedErrorCode = null;
      state.analysisFailedMessage = null;
      state.progressHistory = [];
    },
    clearDocumentDetailsData(state) {
      state.categories = null;
      state.terms = [];
    },
    clearProgressHistory(state) {
      state.progressHistory = [];
    },
    setAnalysis(state, { payload = null }) {
      state.analysis = payload;
    },
    setAnalysisFailed(state, { payload }) {
      state.analysisFailed = true;
      state.analysisFailedMessage =
        payload?.userMessage || payload?.message || "Analysis failed";
      state.analysisFailedErrorCode = payload?.errorCode || null;
    },
    setAlignmentOverviewData(state, { payload }) {
      state.overview = payload || null;
    },
    setCategoriesData(state, { payload }) {
      state.categories = payload || {};
    },
    setIsLoadingTerms(state, { payload: isLoadingTerms = false }) {
      state.isLoadingTerms = isLoadingTerms;
    },
    setIsSubmitting(state, { payload: isSubmitting = false }) {
      state.isSubmitting = isSubmitting;
    },
    setOperationId(state, { payload = null }) {
      state.operationId = payload;
    },
    setProgressHistory(state, { payload = [] }) {
      state.progressHistory = payload || [];
    },
    setSSEError(state, { payload }) {
      state.sseError = Boolean(payload);
    },
    setTermsData(state, { payload }) {
      state.terms = payload || [];
    },
    incrementConnectionAttempts(state) {
      state.connectionAttempts += 1;
    },
    resetConnectionAttempts(state) {
      state.connectionAttempts = 0;
    },
    setConnectionError(state, { payload = null }) {
      state.connectionError = payload;
    },
  },
});

export const {
  setOwner,
  clearOwner,
  addProgressHistory,
  clearAll,
  clearAnalysisFailed,
  clearAnalysisProgress,
  clearDocumentDetailsData,
  clearProgressHistory,
  setAnalysis,
  setAnalysisFailed,
  setAlignmentOverviewData,
  setCategoriesData,
  setIsLoadingTerms,
  setIsSubmitting,
  setOperationId,
  setProgressHistory,
  setSSEError,
  setTermsData,
  incrementConnectionAttempts,
  resetConnectionAttempts,
  setConnectionError,
} = technicalAlignmentSlice.actions;

export default technicalAlignmentSlice.reducer;
